import {
  ScheduleOutlined,
  PushpinOutlined,
  StarOutlined,
  InboxOutlined,
  HistoryOutlined,
  SolutionOutlined,
  TeamOutlined,
  MedicineBoxOutlined,
  ContactsOutlined,
  SendOutlined,
  MessageOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons';
import { isAdmin, isStaff, isSuperAdmin } from '../shared/utils/roles';

// Jedinstven izvor navigacije: koriste ga i bocna navigacija (Sidebar) i
// naslov u topbaru (ikonica + naziv aktivne stranice).
export const navGroups = [
  {
    title: 'Terapije',
    items: [
      { href: '/terapije', label: 'Terapije', icon: ScheduleOutlined },
      {
        href: '/rezervisane-terapije',
        label: 'Rezervisane Th',
        icon: PushpinOutlined,
        visible: isStaff,
      },
      {
        href: '/sacuvane-terapije',
        label: 'Sačuvane Th',
        icon: StarOutlined,
        visible: isStaff,
      },
      {
        href: '/zahtevi',
        label: 'Zahtevi',
        icon: InboxOutlined,
        visible: isStaff,
      },
    ],
  },
  {
    title: 'Aktivnosti',
    items: [
      {
        href: '/istorija-dnevnih-aktivnosti',
        label: 'Dnevne Aktivnosti',
        icon: HistoryOutlined,
        visible: isStaff,
      },
      {
        href: '/korisnicke-izmene',
        label: 'Korisničke izmene',
        icon: SolutionOutlined,
        visible: isAdmin,
      },
    ],
  },
  {
    title: 'Evidencija',
    items: [
      { href: '/korisnici', label: 'Pacijenti', icon: TeamOutlined },
      { href: '/lekovi', label: 'Lekovi', icon: MedicineBoxOutlined },
      // Upravljanje admin nalozima - samo super admin.
      {
        href: '/administratori',
        label: 'Admini',
        icon: SafetyCertificateOutlined,
        visible: isSuperAdmin,
      },
    ],
  },
  {
    title: 'Komunikacija',
    items: [
      { href: '/kontakti', label: 'Kontakti', icon: ContactsOutlined },
      {
        href: '/posiljaoci',
        label: 'Pošiljaoci',
        icon: SendOutlined,
        visible: isStaff,
      },
      { href: '/poruke', label: 'Poruke', icon: MessageOutlined },
    ],
  },
];

// Aktivna stavka na osnovu putanje (tacno poklapanje ili prefiks za pod-rute).
export const findNavItem = (pathname) => {
  for (const group of navGroups) {
    for (const item of group.items) {
      if (pathname === item.href || pathname.startsWith(`${item.href}/`)) {
        return item;
      }
    }
  }
  return null;
};
